import { produce } from 'immer';
import {
  SUBSCRIPTION_RESET,
  SUBSCRIPTION_INIT,
  SUBSCRIPTION_GET_REQUEST,
  SUBSCRIPTION_GET_FAILURE,
  SUBSCRIPTION_DOWNGRADE_REQUEST,
  SUBSCRIPTION_DOWNGRADE_SUCCESS,
  SUBSCRIPTION_DOWNGRADE_FAILURE,
  SUBSCRIPTION_UPDATE_REQUEST,
  SUBSCRIPTION_UPDATE_SUCCESS,
  SUBSCRIPTION_GET_SUCCESS,
  SUBSCRIPTION_UPDATE_FAILURE
} from './actions';
import { SubscriptionAction, SubscriptionState } from './subscription-types';

const initialState: SubscriptionState = {};

const subscription = (state: SubscriptionState = initialState, action: SubscriptionAction): SubscriptionState => {
  if (!action) return state;

  return produce(state, (draft) => reduce(draft, action));
};

function reduce(state: SubscriptionState = initialState, action: SubscriptionAction): SubscriptionState {
  switch (action.type) {
    case SUBSCRIPTION_RESET:
      return {};

    case SUBSCRIPTION_INIT:
      return { ...initialState, ...action.payload };
    case SUBSCRIPTION_GET_REQUEST:
    case SUBSCRIPTION_GET_FAILURE:
    case SUBSCRIPTION_DOWNGRADE_REQUEST:
    case SUBSCRIPTION_DOWNGRADE_SUCCESS:
    case SUBSCRIPTION_DOWNGRADE_FAILURE:
    case SUBSCRIPTION_UPDATE_REQUEST:
    case SUBSCRIPTION_UPDATE_SUCCESS:
      return { ...state, ...action.payload };

    case SUBSCRIPTION_GET_SUCCESS:
      return { ...state, ...action.payload, fetching: false, loaded: true };

    case SUBSCRIPTION_UPDATE_FAILURE:
      const merged = { ...state, ...action.payload };
      merged.working.errorMessage = { ...merged.working.errorMessage, ...action.errorMessage };
      return merged;

    default:
      return state;
  }
}

export default subscription;
